export const SHOW_LOGOUT_MODAL = 'SHOW_LOGOUT_MODAL';

export const SHOW_HELPDESK_MODAL = 'SHOW_HELPDESK_MODAL';
